import Notify from 'quasar/src/plugins/notify/Notify.js';;

const toast = {
  success: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-success',
      icon: 'icon-check-circle',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileSuccess: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-success mobile-toast',
      icon: 'icon-check-circle',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  successSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-success toast-subtext',
      icon: 'icon-check-circle',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileSuccessSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-success toast-subtext mobile-toast',
      icon: 'icon-check-circle',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  warning: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-warning',
      icon: 'icon-warning',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileWarning: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-warning mobile-toast',
      icon: 'icon-warning',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  warningSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-warning toast-subtext',
      icon: 'icon-warning',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileWarningSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-warning toast-subtext mobile-toast',
      icon: 'icon-warning',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  error: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-error',
      icon: 'icon-error',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileError: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-error mobile-toast',
      icon: 'icon-error',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  errorSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-error toast-subtext',
      icon: 'icon-error',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileErrorSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-error toast-subtext mobile-toast',
      icon: 'icon-error',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  info: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-info',
      icon: 'icon-error',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileInfo: (msg) => {
    return Notify.create({
      classes: 'app-toast toast-info mobile-toast',
      icon: 'icon-error',
      message: msg,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  infoSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-info toast-subtext',
      icon: 'icon-info',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
  mobileInfoSub: (msg, cap) => {
    return Notify.create({
      classes: 'app-toast toast-info toast-subtext mobile-toast',
      icon: 'icon-info',
      message: msg,
      caption: cap,
      position: 'top',
      timeout: 2000,
      actions: [
        {
          icon: 'icon-close',
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  },
};

export default toast;
